// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".language-switcher{margin-bottom:20px;width:400px;display:-ms-flexbox;display:flex;-ms-flex-pack:justify;justify-content:space-between}.language-switcher button{margin:0 40px;padding:5px;font-family:\"GothamSSm-Bold\",Arial,sans-serif;color:#9a66bf}.language-switcher button.active{color:inherit;cursor:default}\n", ""]);
// Exports
module.exports = exports;
